"use strict";
exports.millisecondsToHours = millisecondsToHours;
var _index = require("./constants.js");
function millisecondsToHours(milliseconds) {
  const hours = milliseconds / _index.millisecondsInHour;
  return Math.trunc(hours);
}
